import React from 'react';

import styled, { css } from 'styled-components';

import {
  desktop,
  ProductListingFilterStyle,
  ProductSizeFilter as BaseProductSizeFilter,
  useBreakpoint,
} from '@techstyle/react-components';

import { mobile } from '../../styles';
import { filterOutSlipperSizes } from '../../utils/sizes';
import ProductListingFilter from '../ProductListingFilter';

const SizeFilterWrapper = styled.div`
  ${mobile`
    ul {
      padding-left: 0;
      padding-bottom: 0;

      h2 {
        text-transform: uppercase;
        padding-bottom: ${({ theme }) => theme.spacing.tiny}px;
      }
    }
  `}
`;

const gridInputStyle = css`
  width: 48px;
  height: 48px;
  ${desktop`
    width: 40px;
    height: 40px;
  `}
  border-radius: 48px;
  background: transparent;
  color: ${({ theme }) => theme.colors.black900};

  border: 1px solid ${({ theme }) => theme.colors.stone};
`;

const gridInputCheckedStyle = css`
  background-color: ${({ theme }) => theme.colors.black900};
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black900};
`;

const gridLabelStyle = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 16.8px;
  letter-spacing: normal;
  text-align: center;

  color: ${({ isChecked, theme, ...rest }) => {
    return isChecked ? theme.colors.white : theme.colors.default;
  }};
`;

const gridItemStyle = css`
  overflow-wrap: break-word;
  margin: 0;

  ${desktop`
    &:hover > div > span {
      border: 1px solid ${props => props.theme.colors.black900};
    }
  `}

  ${mobile`
    margin: ${({ theme }) => theme.spacing.tiny}px ${({ theme }) =>
    theme.spacing.tiny}px 0 0;
  `}
`;

const gridListStyle = css`
  padding-top: 4px;
  ${mobile`
    padding: 0 0 ${({ theme }) => theme.spacing.moderate}px 0 !important;
  `}
`;

const gridInputFocusStyle = css`
  box-shadow: none;
`;

const bandInputStyle = css`
  ${gridInputStyle}
  ${desktop`
    width: ${({ theme }) => theme.spacing.medium}px;
    height: ${({ theme }) => theme.spacing.medium}px;
  `}
`;
const bandSizeCheckboxProps = { inputStyle: bandInputStyle };
const gridCheckboxProps = {
  inputStyle: gridInputStyle,
  inputCheckedStyle: gridInputCheckedStyle,
  inputFocusStyle: gridInputFocusStyle,
};

function ProductSizeFilter(props) {
  const {
    filterField: { items },
  } = props;
  const newProps = {
    ...props,
    filterField: {
      ...props.filterField,
      items: filterOutSlipperSizes(items),
    },
  };
  const { isDesktop } = useBreakpoint();

  const baseProductSizeFilter = (
    <BaseProductSizeFilter
      as={ProductListingFilter}
      bandSizeCheckboxProps={bandSizeCheckboxProps}
      filterStyle={ProductListingFilterStyle.GRID}
      gridCheckboxProps={gridCheckboxProps}
      gridItemStyle={gridItemStyle}
      gridListStyle={gridListStyle}
      gridLabelStyle={gridLabelStyle}
      {...newProps}
    />
  );

  if (!isDesktop) {
    return <SizeFilterWrapper>{baseProductSizeFilter}</SizeFilterWrapper>;
  }
  return baseProductSizeFilter;
}

export default ProductSizeFilter;
